import { backToParent } from '../../_utils/navTrail'

/**
 * Back from a Marketing page, never forward.
 *
 * Opened by a page that said so (it pushed us with `{ from }`): back to that
 * page, which is the entry before this one, so the history doesn't grow.
 * Arrived some other way (a link, Bailey, a refresh on a deep link): this
 * page is swapped for its parent. Either way Back afterwards leaves for
 * wherever you were before, instead of bouncing between a page and the one
 * above it (Marketing ⇄ Config).
 */
export function goUp(history, location, parent) {
  const from = location && location.state && location.state.from
  if (from && history.length > 1) history.goBack()
  else backToParent(history, parent)
}

/** The page Back returns to: the one that opened this one, or the parent. */
export function backTarget(location, parent) {
  const from = location && location.state && location.state.from
  return from || parent
}

/** What's left of a page's route state once its one-off asks are spent: only where Back goes. */
export const keepFrom = (location) => {
  const from = location && location.state && location.state.from
  return from ? { from } : {}
}
